import React from 'react';
import { Button, Card, Space, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import OperatorVendorList from '@/components/vendor/OperatorVendorList';
import { useAuthStore } from '@/store/authStore';
import { canCreateVendor } from '@/store/vendorAccess';

const { Title, Text } = Typography;

const OperatorVendorsPage: React.FC = () => {
  const navigate = useNavigate();
  const { authorization } = useAuthStore();

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <Space style={{ width: '100%', justifyContent: 'space-between' }} align="start">
          <div>
            <Title level={2} style={{ marginBottom: 0 }}>Vendors</Title>
            <Text type="secondary">Vendors in your business unit(s)</Text>
          </div>
          {canCreateVendor(authorization) && (
            <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/vendors/new')}>
              Create vendor
            </Button>
          )}
        </Space>
      </div>
      <Card>
        <OperatorVendorList />
      </Card>
    </div>
  );
};

export default OperatorVendorsPage;
